import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { compose } from 'recompose';
import { Card, Button } from 'semantic-ui-react';

import REPORT_TYPES from '../../utils/report-types';
import OLD_REPORT_TYPES from '../../utils/report-types-legacy';
import reportCard from './report-card';
import oldReportCard from './report-card-legacy';
import TargetLink from '../../components/target-link';

import hasRESTClient from '../../hocs/has-rest-client';
import hasJSONAPIClient from '../../hocs/has-jsonapi-client';
import hasOrgansation from '../../hocs/has-organisation';

const bookingLinkStyle = {
  color: 'rgb(32, 196, 158)',
};

const BOOK_A_DEMO = 'https://dyzio.co/book-a-demo';

const isFreeReport = type => _.isEqual(type, 'free');
const isPremiumReport = type => _.isEqual(type, 'premium');
const ZIP_API = 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/stories/zip';

class ReportsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      campaign: null,
      isLoadingCampaign: true,
      storyZipUrl: null,
      requestZipLoading: false,
      requestZipDisabled: false,
    };
    console.log('ReportsList constructor');
  }

  getZipRequestStatus = async () => {
    const {
      params: { id: campaignId },
      restClient,
    } = this.props;

    const campaign = await restClient.get(`campaigns/${campaignId}`).then(r => r.data.data);

    const { storyZipUrl } = campaign.attributes;

    return storyZipUrl;
  }
  componentDidMount = async () => {
    const {
      params: { id: campaignId },
      jsonAPIClient,
    } = this.props;
    const storyZipUrl = await this.getZipRequestStatus();
    console.log('ReportsList componentDidMount');
    const response = await jsonAPIClient.get('campaigns', campaignId);
    const campaign = response.toJSONTree();
    this.setState({
      campaign,
      isLoadingCampaign: false,
      storyZipUrl,
    });
  }

  requestZipFile = async () => {
    const {
      params: { id: campaignId },
      restClient,
    } = this.props;
    let storyZipUrl = null;
    storyZipUrl = {
      url: 'requesting...',
      createdDate: 'requesting...',
    };
    this.setState({
      storyZipUrl,
      requestZipLoading: true,
      requestZipDisabled: true,
    });
    const requestPayload = {
      data: {
        campaignId,
      },
    };
    const response = await restClient.post(ZIP_API, requestPayload).catch(err => {
      console.log(err.message);
    });


    if (response) {
      storyZipUrl = {
        url: response.data.zipUrl,
        createdDate: new Date().toISOString(),
      };
    }
    this.setState({
      requestZipLoading: false,
      requestZipDisabled: false,
      storyZipUrl,
    });
  }

  render() {
    const { organisation } = this.props;
    const { licenseSubscriptionType } = organisation || {};
    const isFreeAccount = _.isEqual(licenseSubscriptionType, 'FREE');
    const {
      isLoadingCampaign,
      campaign,
      storyZipUrl,
      requestZipLoading,
      requestZipDisabled,
    } = this.state;

    const ELEMIS = 'df27f0a0-7ad2-4161-b14e-f928b464a85b';
    const DYZIO = 'f14d3931-0e6a-42e8-ad3c-ae2ff07e3d96';
    const LAUNCH = '4a6b0ee0-6c1a-423b-984f-49a7cb849d1e';
    const orgs = [
      ELEMIS,
      LAUNCH,
      DYZIO,
    ];
    const shouldShowZip = _.includes(orgs, organisation.id);
    const isShopifyCampaign = _.get(campaign, 'isShopifyCampaign');

    console.log('campaign', campaign);
    console.log('isShopifyCampaign', isShopifyCampaign);

    return (
      <div>
        { !isLoadingCampaign && !isFreeAccount &&
          <div>
            {
              shouldShowZip &&
              <Card fluid>
                <Card.Content>
                  <Card.Header>
                Download Story Media
                  </Card.Header>
                </Card.Content>
                <Card.Content>
                  <Card.Meta>
                  Click on the button to request a zip file of all the story media your campaign has collected.
                  Large campaigns may take a couple of minutes to prepare.
                  </Card.Meta>
                </Card.Content>
                { storyZipUrl &&
                <Card.Content>
                  <p>download link:&nbsp;
                    <a target="_blank" href={storyZipUrl.url}>{requestZipLoading ? 'requesting...' : 'STORY ZIP FILE'}</a>
                  </p>
                  <p>created date: {storyZipUrl.createdDate}</p>
                </Card.Content>
                }
                <Card.Content>
                  <Button
                    disabled={requestZipDisabled}
                    loading={requestZipLoading}
                    onClick={this.requestZipFile}
                  >Request ZIP FILE</Button>
                </Card.Content>
              </Card>
            }

            <Card fluid>
              <Card.Content>
                <Card.Header>
              Standard Campaign Reports
                </Card.Header>
              </Card.Content>
              <Card.Content>
                <Card.Meta>
              Click on the cards below to access your campaign reports.
              Each report is easily shareable,
              just copy the link in the report and share via email to your colleagues or clients.
              No login is required to view the shareable reports.
              Reports will show data once your influencers start posting.
                </Card.Meta>
              </Card.Content>
              <Card.Content>
                <Card.Group itemsPerRow={4}>
                  { _.map(_.filter(REPORT_TYPES, report => isPremiumReport(report.type)), r =>
                    reportCard.ReportCard(r, campaign, organisation),
                  )}
                </Card.Group>
              </Card.Content>
            </Card>
          </div>
        }
        { !isLoadingCampaign && !isFreeAccount &&
        <Card fluid>
          <Card.Content>
            <Card.Header>
              Integration Reports
            </Card.Header>
          </Card.Content>
          <Card.Content>
            <Card.Meta>
            The Integration Reports are only available on Enterprise plans -
            you will need to upgrade your account to access these reports.
            Each of these reports requires a 3rd party integration to activate all
            the data and features in the reports (e.g. Facebook Ads Manager, Google Analytics or Shopify).
              <TargetLink
                style={bookingLinkStyle}
                renderIf href={BOOK_A_DEMO}
              > Click here
              </TargetLink> to book a call to discuss the Enterprise plans with the Dyzio team.
            </Card.Meta>
          </Card.Content>
          <Card.Content>
            <Card.Group itemsPerRow={4}>
              { _.map(_.filter(REPORT_TYPES, report => !isPremiumReport(report.type)), r =>
                reportCard.ReportCard(r, campaign, organisation),
              )}
            </Card.Group>
          </Card.Content>
        </Card>
        }

        { !isLoadingCampaign && isFreeAccount &&
        <Card fluid>
          <Card.Content>
            <Card.Header>
              Basic Reports
            </Card.Header>
          </Card.Content>
          <Card.Content>
            <Card.Meta>
              Click on the cards below to access your campaign reports.
              Each report is easily shareable,
              just copy the link in the report and share via email to your colleagues or clients.
              No login is required to view the shareable reports.
              Reports will show data once your influencers start posting.
            </Card.Meta>
          </Card.Content>
          <Card.Content>
            <Card.Group itemsPerRow={4}>
              { _.map(_.filter(OLD_REPORT_TYPES, report => isFreeReport(report.type)), r =>
                oldReportCard.ReportCard(r, campaign, organisation),
              )}
            </Card.Group>
          </Card.Content>
        </Card>
        }
        { !isLoadingCampaign && isFreeAccount &&
        <Card fluid>
          <Card.Content>
            <Card.Header>
              Premium Reports
            </Card.Header>
          </Card.Content>
          <Card.Content>
            <Card.Meta>
              The Premium Reports are only available on a Dyzio paid plan - you will
              need to upgrade your account to access these reports. A number of these Premium
              Reports also require a 3rd party integration to activate all the data and
              features in the reports
              (e.g. Facebook Ads Manager or Google Analytics). <TargetLink
                style={bookingLinkStyle}
                renderIf href={BOOK_A_DEMO}
              >
              click here
              </TargetLink> to book a call to discuss the paid plans with the Dyzio team.
            </Card.Meta>
          </Card.Content>
          <Card.Content>
            <Card.Group itemsPerRow={4}>
              { _.map(_.filter(OLD_REPORT_TYPES, report => !isFreeReport(report.type)), r =>
                oldReportCard.ReportCard(r, campaign, organisation),
              )}
            </Card.Group>
          </Card.Content>
        </Card>
        }

      </div>
    );
  }
}

ReportsList.propTypes = {
  campaignId: PropTypes.string.isRequired,
  organisation: PropTypes.object.isRequired,
};


export default compose(
  hasOrgansation,
  hasJSONAPIClient,
  hasRESTClient,
)(ReportsList);



/** WEBPACK FOOTER **
 ** ./src/containers/report-list/index.js
 **/